module.exports = __webpack_public_path__ + "img/envelopeOpenTextIcon.a8cc2f3a.svg";